"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Client = void 0;
/**
 * Creates an instance of Client.
 *
 * This is a simple client that is used to model the request process.
 *
 * @internal
 */
class Client {
    /**
     * Creates an instance of Client.
     *
     * @param apiBaseURL - The base URL for the API to be called. The trailing slashes will be removed.
     */
    constructor(apiBaseURL) {
        this.apiBaseURL = apiBaseURL;
        apiBaseURL = apiBaseURL.replace(/~+$/, "/");
    }
    /**
     * Makes a call to the API and returns the response.
     *
     * @typeParam T - Type of response
     * @typeParam U - Type of error
     *
     * @throws `Error` class contain information about the failed request
     *
     * @param path - The API endpoint path. If it doesn't start with a slash, one will be added to the beginning.
     * @param req - The request options (contain header, method, ...) to be passed to `fetch`.
     * @param body - The request body to be sent with the API call. If present, the Content-Type header will be set to "application/json".
     *
     * @returns A tuple containing the API response as a `Promise` of type `T`, and the error as type `U` if any. The error will be `null` if the call is successful.
     */
    call(path, req, body) {
        return __awaiter(this, void 0, void 0, function* () {
            // handle the slashe duplication.
            const realPath = path[0] !== "/" ? `/${path}` : path;
            // If the body is not already define in the req, define it.
            if (body !== null && !req.body) {
                req.headers["Content-Type"] = "application/json";
                req.body = JSON.stringify(body);
            }
            // Do the fetch request.
            const response = yield fetch(`${this.apiBaseURL}${realPath}`, req);
            // If the response was successful.
            if (response.ok) {
                if (response.status !== 204) {
                    return [response.json(), null];
                }
                return [null, null];
            }
            // If the response was not successful, log an error to the console with the failed request URL.
            console.error(`Failed to do the request: ${this.apiBaseURL}${realPath}`);
            // Try to parse the error response as JSON and return a tuple with a null response and the error.
            if (response.status >= 400) {
                try {
                    const err = (yield response.json());
                    return [null, err];
                }
                catch (e) {
                    console.error(`Failed to parse error response body: ${e}`);
                }
            }
            // Throw an error with the invalid API.
            throw new Error(`Invalid API response ${response.status}: ${response.statusText}`);
        });
    }
}
exports.Client = Client;
//# sourceMappingURL=Client.js.map